<template>
      <div class="wrapper flex xs-middle" :class="status">
            <!-- Slot for icons -->
            <slot name="icon" v-if="this.value === '' || this.value === null"></slot>
            <input
                  type="text"
                  class="afizo"
                  :class="size"
                  :value="value"
                  :placeholder="placeholder"
                  :id="id"
                  @focus="$emit('focus')"
                  @blur="$emit('blur')"
                  @input="$emit('input', $event.target.value)"
                  :disabled="isReadOnly"
                  :data-fup="`input/${id}`"
            />
      </div>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return val === null || typeof val === "string"
			}
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					[
						"xsmall",
						"small",
						"medium",
						"large",
						"xlarge"
					].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return (
					val === null ||
					["error", "success", "warning"].includes(val)
				)
			}
		},
		placeholder: {
			type: String,
			required: false
		},
		id: {
			type: String,
			required: false
		},
		isReadOnly: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style src="./index.css" scoped />
